import React, { memo } from 'react';

function Title() {
	return (
		<>
			<h1>todos</h1>
		</>
	);
}

export default memo(Title);
